import { render } from "./CadastrarLivro.vue?vue&type=template&id=72f5d75a&scoped=true"
import script from "./CadastrarLivro.vue?vue&type=script&lang=js"
export * from "./CadastrarLivro.vue?vue&type=script&lang=js"

import "./CadastrarLivro.vue?vue&type=style&index=0&id=72f5d75a&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f5d75a"]])

export default __exports__